<template>
    <div class="activity-sidebar">
        <div class="top">
            <div class="first">
                <SupsisButton ghost classNames="border-none" @click="goBack">
                    <i class="material-icons">chevron_left</i>
                    {{ $t("message.turnBack") }}
                </SupsisButton>
            </div>
            <div class="second">
                <div class="btnGroup">
                    <SupsisButton classNames="btnGroupItem selected" primary @click="goActivities"
                        >{{ $t("notification.activities") }}
                    </SupsisButton>
                    <SupsisButton classNames="btnGroupItem" ghost @click="goNotifications"
                        >{{ $t("notification.notifications") }}
                    </SupsisButton>
                </div>
            </div>
            <div class="third">
                <div>
                    <div>{{ $t("notification.selectActor") }}</div>
                    <a-select
                        v-model="filters.actorIds"
                        class="select-multiple"
                        mode="multiple"
                        :placeholder="$t('notification.selectActor')"
                        :options="users"
                    ></a-select>
                </div>
                <div>
                    <div>{{ $t("notification.dateBetween") }}</div>
                    <div class="date-calender">
                        <input
                            type="date"
                            :value="startDateValue"
                            :placeholder="$t('message.startDate')"
                            class="custom-date-input"
                            @input="onStartDateChange"
                        />
                        <input
                            type="date"
                            :value="endDateValue"
                            :placeholder="$t('message.endDate')"
                            class="custom-date-input"
                            @input="onEndDateChange"
                        />
                    </div>
                </div>
                <div>
                    <div>{{ $t("notification.actionType") }}</div>
                    <a-select
                        v-model="filters.activityTypes"
                        class="select-multiple"
                        mode="multiple"
                        :placeholder="$t('notification.actionType')"
                        :options="types"
                    ></a-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapState } from "vuex";
import _ from "lodash";
import SupsisButton from "../Settings/components/SupsisButton.vue";

export default Vue.extend({
    name: "ActivitySidebar",
    components: { SupsisButton },
    props: {
        filter: {
            type: Object,
            default: () => ({
                actorIds: [],
                startDate: null,
                endDate: null,
                activityTypes: [],
            }),
        },
    },
    data: () => {
        return {
            filters: {},
            typeValues: [
                "chat-assign",
                "ticket-assign",
                "task-assign",
                "task-complet",
                "chat-close-own",
                "tag-actions-to-visitor",
                "create-ticket",
                "note-actions-to-visitor",
                "visitor-profile-updates",
                "chat-start",
                "user-crud",
                "department-crud",
                "settings-crud",
                "integration-channel-crud",
                "login-form-crud",
                "banned-word-crud",
                "email-account-crud",
                "prepared-content-crud",
                "role-crud",
                "tag-crud",
                "welcome-message-crud",
                "webhook-crud",
                "automation-created",
                "automation-deleted",
                "automation-restored",
                "automation-published",
                "automation-unpublished",
                "automation-updated",
                "form-created",
                "form-updated",
                "form-deleted",
                "form-restored",
                "form-downloaded",
                "user-role-changed",
                "user-password-changed",
                "user-email-changed",
                "user-name-changed",
                "user-phone-changed",
                "user-disabled",
                "role-updated",
                "task-workflow-updated",
                "task-workflow-restored",
                "task-workflow-permanently-deleted",
                "task-workflow-pipeline-stage-added",
                "task-workflow-pipeline-stage-updated",
                "task-workflow-pipeline-stage-deleted",
                "drive-folder-created",
                "drive-folder-deleted",
                "drive-folder-renamed",
                "drive-file-added",
                "drive-file-deleted",
                "task-module-rules-enabled",
                "task-module-rules-disabled",
                "task-module-rules-rule-added",
                "task-module-rules-rule-deleted",
                "task-module-rules-rule-updated",
                "task-module-rules-rule-enabled",
                "task-module-rules-rule-disabled",
                "contact-module-rules-enabled",
                "contact-module-rules-disabled",
                "contact-module-rules-rule-added",
                "contact-module-rules-rule-updated",
                "contact-module-rules-rule-deleted",
                "contact-module-rules-rule-enabled",
                "contact-module-rules-rule-disabled",
                "developer-token-changed",
                "table-created",
                "table-deleted",
                "table-restored",
                "table-permanently-deleted",
                "table-field-added",
                "table-field-updated",
                "table-field-deleted",
                "table-view-added",
                "table-view-updated",
                "table-view-deleted",
                "table-page-added",
                "table-page-updated",
                "table-page-deleted",
                "table-widget-added",
                "table-widget-updated",
                "table-widget-deleted",
                "table-privacy-changed",
                "web-app-created",
                "web-app-updated",
                "web-app-deleted",
                "web-tab-created",
                "web-tab-updated",
                "web-tab-deleted",
                "module-created",
                "module-updated",
                "module-deleted",
                "relation-created",
                "relation-updated",
                "voice-agent-created",
                "voice-agent-updated",
                "voice-agent-deleted",
                "voice-agent-phone-number-inbound-agent-changed",
                "voice-agent-phone-number-outbound-agent-changed",
                "voice-agent-batch-call-created",
                "voice-agent-knowledge-base-created",
                "voice-agent-knowledge-base-deleted",
                "table-data-downloaded",
                "table-data-imported",
                "table-data-batch-updated",
                "table-data-batch-deleted",
                "contact-batch-updated",
                "chat-data-downloaded",
                "billing-events",
                "task-workflow-crud",
                "task-crud",
                "system-status",
                "chatbot-story-crud",
                "chatbot-forward-chat",
                "chatbot-user-segment-crud",
                "chatbot-credit-low",
                "chatbot-ai-model-updated",
                "whatsapp-credit-low",
                "whatsapp-customer-group-crud",
                "whatsapp-broadcast-message-crud",
                "whatsapp-template-message-crud",
                "waba_supsis_partner_remove",
                "waba_supsis_partner_added",
                "waba_supsis_account_deleted",
                "waba_supsis_account_violation",
                "waba_supsis_ad_account_linked",
                "waba_supsis_auth_intl_price_eligibility_update",
                "waba_supsis_disabled_update",
                "waba_supsis_mm_lite_terms_signed",
                "waba_supsis_partner_app_installed",
                "waba_supsis_partner_app_uninstalled",
                "waba_supsis_partner_client_certification_status_update",
                "waba_supsis_business_primary_location_country_update",
                "waba_supsis_volume_based_pricing_tier_update",
                "waba_supsis_message_template_components_update",
                "waba_supsis_message_template_status_update",
                "waba_supsis_template_category_update",
            ],
        };
    },
    computed: {
        ...mapState({
            rawUsers: (state) => state.user.users.data,
        }),
        types() {
            return this.typeValues.map((value) => ({
                value,
                label: this.$t(`notification.activityTypeLabels["${value}"]`),
            }));
        },
        users() {
            const baseUsers = [
                { value: "system", label: this.$t("message.system") },
                { value: "chatbot", label: this.$t("chatWindow.chatbotContact") },
            ];
            if (!this.rawUsers) return baseUsers;
            return [
                ...baseUsers,
                ...this.rawUsers.map((user) => ({
                    value: user._id,
                    label: user.name,
                })),
            ];
        },
        startDateValue() {
            if (!this.filters.startDate) return "";
            return this.$moment(this.filters.startDate).format("YYYY-MM-DD");
        },
        endDateValue() {
            if (!this.filters.endDate) return "";
            return this.$moment(this.filters.endDate).format("YYYY-MM-DD");
        },
    },
    methods: {
        onStartDateChange(event) {
            const value = event.target.value;
            if (value) {
                this.$set(this.filters, 'startDate', this.$moment.utc(value, "YYYY-MM-DD").startOf("day").toDate());
            } else {
                this.$set(this.filters, 'startDate', null);
            }
        },
        onEndDateChange(event) {
            const value = event.target.value;
            if (value) {
                this.$set(this.filters, 'endDate', this.$moment.utc(value, "YYYY-MM-DD").endOf("day").toDate());
            } else {
                this.$set(this.filters, 'endDate', null);
            }
        },
        goBack() {
            this.$router.push("/chat");
        },
        goActivities() {
            this.$router.push("/activities");
        },
        goNotifications() {
            this.$router.push("/notifications");
        },
    },
    mounted() {
        this.filters = _.cloneDeep(this.filter);
    },
    watch: {
        filter: {
            deep: true,
            handler(oldVal, newVal) {
                if (!_.isEqual(oldVal, newVal)) {
                    this.filters = this.filter;
                }
            },
        },
        filters: {
            deep: true,
            handler(newVal, oldVal) {
                    this.$emit("filtered", this.filters);
            },
            immediate: false,
        },
    },
});
</script>
<style lang="scss">
.activity-sidebar {
    .third {
        .date-calender {
            display: flex;
            flex-direction: column;
            gap: 5px;

            .custom-date-input {
                width: 100%;
                padding: 10px 14px;
                border: 1px solid #d9d9d9;
                border-radius: 4px;
                    background-color: #f1f4f7;
                font-size: 14px;
                outline: none;
                transition: all 0.3s;

                &:focus {
                    border-color: #40a9ff;
                    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
                }

                &::-webkit-calendar-picker-indicator {
                    cursor: pointer;
                }
            }
        }
    }
    .ant-select {
        width: 100%;
        .ant-select-selection {
            background-color: #f1f4f7 !important;
            .ant-select-selection__choice {
                color: rgb(255 255 255);
                background-color: #22272d;
                border-radius: 5px;
                svg[data-icon="close"] {
                    fill: white;
                }
            }
        }
    }
}
</style>

<style scoped lang="scss">
.activity-sidebar {
    overflow-y: auto;
    height: calc(100vh - 93px);
    max-height: 100%;
    width: 275px;
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-right: 1px solid var(--color-border-default);

    .border-none {
        border: none !important;
    }

    .top {
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 20px 0;

        .first,
        .second,
        .third {
            padding: 0 20px;
            width: 100%;
        }

        .third {
            width: 100%;
            display: flex;
            gap: 10px;
            flex-direction: column;
        }

        .btnGroup {
            display: flex;
            border: 1px solid var(--color-border-default);
            border-radius: 6px;
            background: var(--color-bg-neutral-default);
            padding: 2px;

            .btnGrupItem {
                &.selected {
                    background: var(--color-bg-oncomponent-default);
                    box-shadow: var(--shadow-interaction-200);
                }
            }

            .supsis-button {
                border: none !important;
                font-size: 14px;
            }
        }

        .filter-groups {
            display: flex;
            flex-direction: column;

            .filter-group {
                display: flex;
                flex-direction: row;
                gap: 5px;
                align-items: center;
                padding: 16px 20px;
                cursor: pointer;

                &:not(.expanded):hover {
                    background: var(--color-bg-hover);
                    text-decoration: underline;
                }
            }

            .filters-wrapper {
                padding: 5px 16px !important;

                .filters {
                    position: relative;
                    border-radius: 4px;
                    border: 1px solid var(--color-border-default);
                    background-color: #f5f7fa;

                    .filter {
                        display: flex;
                        align-items: flex-start;
                        margin: 7px 0;

                        .filter-name {
                            flex: 1;
                            padding: 0 3px;
                            padding-top: 5px;
                        }
                    }

                    .close-icon {
                        position: absolute;
                        right: 5px;
                        top: 5px;
                        cursor: pointer;
                    }

                    .from,
                    .to {
                        padding: 5px;
                        cursor: text;
                        margin: 20px 8px;
                        border: 1px solid var(--color-border-default);
                        border-radius: 4px;
                    }
                }
            }
        }
    }

    .bottom {
        padding: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}
</style>
